<template>
  <Table
    :items="itemsProp"
    :hideColumns="hideColumns"
    :showColumns="showColumns"
    :loading="loading"
    :refresh="refresh"
    :totalItemCount="totalItemCountProp"
    :actions="actions"
    @refresh="onRefresh"
    @paginationChanged="onPaginationChanged"
  />
</template>

<script>
import { ClassMemberNullError } from "../../../errors/index";

export default {
  props: {
    request: {
      type: Function,
      required: false,
    },
    hideColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
    showColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
    refresh: {
      type: Boolean,
      required: false,
      default: true,
    },
    pagination: {
      type: Boolean,
      required: false,
      default: false,
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
  }, // props

  data: () => ({
    items: [],
    tableResponse: {
      data: [],
      filteredCount: 0,
      totalCount: 0,
    },
    pageIndex: 0,
    pageSize: 10,
    loading: false,
  }), // data

  mounted() {}, // mounted

  computed: {
    itemsProp() {
      return this.pagination ? this.tableResponse.data : this.items;
    },
    totalItemCountProp() {
      return this.pagination
        ? this.tableResponse.totalCount
        : this.items.length;
    },
  }, // computed

  methods: {
    onPaginationChanged({ pageIndex, pageSize }) {
      this.pageIndex = pageIndex;
      this.pageSize = pageSize;
      this.executeRequestIfValidAsync();
    },
    onRefresh() {
      this.executeRequestAsync();
    },
    /** Exported (used in ref) */
    async executeRequestAsync() {
      ClassMemberNullError.throw(
        this.request,
        "RequestTable.request",
        this.executeRequestAsync.name
      );

      if (this.pagination) {
        ClassMemberNullError.throw(
          this.pageIndex,
          "RequestTable.pageIndex",
          this.executeRequestAsync.name
        );

        ClassMemberNullError.throw(
          this.pageSize,
          "RequestTable.pageSize",
          this.executeRequestAsync.name
        );
      }

      this.tableResponse.data = [];
      this.items = [];
      this.loading = true;

      try {
        const response = await this.request({
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        });

        if (this.pagination) {
          this.tableResponse = response;
        } else {
          this.items = response;
        }
      } catch (error) {
        throw new Error(`Could not execute RequestTable.request: ${error}`);
      } finally {
        this.loading = false;
      }
    },
    async executeRequestIfValidAsync() {
      if (this.pageIndex == undefined || this.pageIndex == null) return;
      if (this.pageSize == undefined || this.pageSize == null) return;
      await this.executeRequestAsync();
    },
  }, // methods
};
</script>
